/**
 * @description: 格式化数值为 xxx,xxx,xxx
 * 将数字位数补足为3的倍数，通过正则切割每三个数字一个分组
 * @param {Number} val 传入数值
 * @return {Number}
 */
export function toThousands(val) {
  var num = (val || 0).toString(),
    temp = num.length % 3
  switch (temp) {
    case 1:
      num = '00' + num
      break
    case 2:
      num = '0' + num
      break
  }
  return num.match(/\d{3}/g).join(',').replace(/^0+/, '')
}

/**
 * @description: 去掉月份日期前的0
 * @param {string} str 传入数值
 * @return {string}
 */
export function dislodgeZero(str) {
  let strArray = str.split('.')
  strArray = strArray.map(function (val) {
    if (val[0] == '0') {
      return (val = val.slice(1))
    } else {
      return val
    }
  })
  return strArray.join('.')
}
/**
 * @description: 获取当前日期前一天YYYY.MM.DD
 * @return {string}
 */
export function getLastDate() {
  let curTime = new Date(Date.now() - 86400000)
  return `${curTime.getFullYear()}.${curTime.getMonth() + 1 < 10 ? '0' + (curTime.getMonth() + 1) : curTime.getMonth() + 1
    }.${curTime.getDate()}`
}
/**
 * @description: 获取指定年月的最后一天dd
 * @param {Number} year 指定年份
 * @param {Number} month 指定月份
 * @return {string}
 */
export function getEndDate(year, month) {
  return 32 - new Date(year, month - 1, 32).getDate()
}

/**
 * @description: 时间戳转YYYY-MM-DD HH:mm:ss
 * @param {string} timestamp 传入时间戳
 * @return {string}
 */
export function timestampToTime(timestamp, format = 'YY-MM-DD') {
  if(!timestamp) return ''
  let date = new Date(timestamp) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let year = date.getFullYear() + '-'
  let month = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  let day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  let formattedTime = format
    .replace('YY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds);

  return formattedTime;
}

/**
 * @description: 判断传入时间是否在本周
 * @param {timestamp/string} param 传入参数
 * @return {type} default:timestamp;可选:datetime
 */
export function weekJudge(param, type = 'timestamp') {
  // 如果传入的时间戳是字符串，需要进行类型转换
  if (typeof param === 'string' && type == 'timestamp') {
    param = Number(param)
  }
  if (type == 'datetime') {
    // ios日期时间兼容
    param = param.replace(/-/g, '/')
  }
  let paramStamp = new Date(param).setHours(0, 0, 0, 0) // 传入的时间戳，将时间部分转换为0
  let currentDate = new Date() // 当天
  let currentStamp = currentDate.setHours(0, 0, 0, 0) // 当天日期，转换为时间部分为0的时间戳
  let currentDay = currentDate.getDay() == 0 ? 7 : currentDate.getDay() // 当天周几，取值为（0-6），0为周日，转换为7
  console.log('当天周：', currentDay, currentDate)
  let dayTime = 24 * 60 * 60 * 1000 // 一天的毫秒数
  let MondayStamp = currentStamp - (currentDay - 1) * dayTime // 本周周一初时间戳（本周一的0点）
  console.log('本周周一：', new Date(MondayStamp))
  let SundayStamp = currentStamp + (8 - currentDay) * dayTime // 本周周日末时间戳（下周一的0点）
  console.log('下周周一：', new Date(SundayStamp))
  // 当传入的时间戳满足[本周一0点，下周一0点) ，说明传入的时间在本周内
  if (paramStamp >= MondayStamp && paramStamp < SundayStamp) {
    return true
  }
  return false
}

// 获取第一层级数据
export function getCascader(initTreeData = []) {
  console.log('getCas', initTreeData)
  if (!initTreeData) return []
  let treeData = []
  let index = 0
  for (let i of initTreeData) {
    if (i.parent == 0) {
      index++
      var itemTree = {
        name: i.name,
        id: i.id,
        sort: index,
        disabled: true,
      }
      let children = getChildren(i.id, initTreeData, index)
      itemTree.children = children.childs
      index = children.index
      treeData.push(itemTree)
    }
  }

  return treeData
}

// 封装生成Cascader级联数据-获取子级
function getChildren(id, initTreeData, index) {
  let childs = []
  for (let j of initTreeData) {
    if (j.parent == id) {
      index++
      childs.push({
        name: `  ${j.name}  `,
        id: j.id,
        sort: index,
        disabled: false,
      })
    }
  }
  for (let n of childs) {
    let childscopy = getChildren(n.id, initTreeData, index)
    if (childscopy.childs.length > 0) {
      n.children = childscopy.childs
    }
  }
  return { childs, index }
}
